// extracted by mini-css-extract-plugin
module.exports = {"chartFrame":"QueryTimeline_chartFrame__1jLNX"};